import { replayClient, stripBodies } from './client';
import { NetworkEventPayload, redactNetworkEvent } from './redaction';

/** Kendi uçlarımız kayda girmez (sonsuz döngü + gereksiz boyut). */
const SELF_URL_RE = /\/replay\/(ingest|config|sessions|live-sessions|admin)/;
/**
 * Kişisel veri taşıyan panel uçları (ad, telefon, e-posta, mesaj; arama terimi URL'de) kayda hiç girmez.
 * Destek Talepleri ortak `instance` kullandığından ağ olayı burada düşürülür.
 */
const PII_URL_RE = /\/support-requests(?:[/?#]|$)/;

export const newRequestId = (): string =>
  crypto.randomUUID ? crypto.randomUUID() : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;

export const headersToRecord = (headers: HeadersInit | Headers | undefined): Record<string, string> => {
  const out: Record<string, string> = {};
  if (!headers) return out;
  if (headers instanceof Headers) {
    headers.forEach((v, k) => {
      out[k] = v;
    });
    return out;
  }
  if (Array.isArray(headers)) {
    headers.forEach(([k, v]) => {
      out[k] = v;
    });
    return out;
  }
  return { ...(headers as Record<string, string>) };
};

/**
 * `api/config.ts instance()` her istekten sonra çağırır. İstemci tarafı
 * redaksiyon burada yapılır; sunucu ingest'te ikinci kez redakte eder.
 * Asla fırlatmaz.
 */
export function captureNetwork(entry: NetworkEventPayload): void {
  try {
    if (SELF_URL_RE.test(entry.url) || PII_URL_RE.test(entry.url)) return;
    const redacted = redactNetworkEvent({ ...entry, capturedAt: entry.capturedAt ?? Date.now() });
    if (!replayClient.isRecording) {
      // Kayıt henüz başlamadı: tam sakla, başlarken izne göre kırpılır
      replayClient.queueNetwork(redacted);
      return;
    }
    replayClient.custom('network', replayClient.bodiesEnabled ? redacted : stripBodies(redacted));
  } catch {
    /* kayıt asla uygulamayı bozmaz */
  }
}
